import { Button } from '@/common/ui/button'
import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs'
import { useEffect } from 'react'

interface DataTableStatusSelectorProps {
	options: { label: string; value: string }[]
	label: string
	paramKey: string
	defaultValues?: string[]
}

export function DataTableStatusSelector({
	options,
	label,
	paramKey,
	defaultValues,
}: DataTableStatusSelectorProps) {
	const [value, setValue] = useQueryState(
		paramKey,
		parseAsArrayOf(parseAsString).withDefault([]),
	)

	useEffect(() => {
		if (!value && defaultValues) {
			setValue(defaultValues)
		}
	}, [defaultValues, setValue, value])

	const currentValues = value || []

	const handleClick = (clickedValue: string) => {
		if (currentValues.includes(clickedValue)) {
			const newValues = currentValues.filter((v) => v !== clickedValue)
			setValue(newValues.length > 0 ? newValues : null)
		} else {
			setValue([...currentValues, clickedValue])
		}
	}

	return (
		<div className="flex flex-col gap-2 sm:gap-3">
			<label className="text-sm font-medium">{label}</label>
			<div className="flex flex-wrap gap-2">
				{options.map((option) => (
					<Button
						key={option.value}
						variant={
							currentValues.includes(option.value) ? 'default' : 'outline'
						}
						onClick={() => handleClick(option.value)}
						className="h-8 px-3 text-xs sm:text-sm"
						size="sm"
					>
						{option.label}
					</Button>
				))}
			</div>
		</div>
	)
}
